import React from "react";
import { Tabs } from "antd";
import CandidateProfileForm from "../candidateProfileForm";
import CandidateProfilePreview from "../candidateProfilePreview";

import "./candidateProfile.scss";
import NujobsCandidateProfileForm from "../qhrflowNuJobs/nuJobsCandidateProfileForm";

const onChange = (key) => {
  console.log(key);
};

function CandidateProfile({ jdID, resumeID }) {
  
  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const items = [
    {
      key: "1",
      label: "Form",
      children: userData.productsignon.toLowerCase().includes("qhrflow")?
                <CandidateProfileForm jdID={jdID} resumeID={resumeID} />:
                <NujobsCandidateProfileForm jdID={jdID} resumeID={resumeID} />,
    },
    {
      key: "2",
      label: "Resume",
      children: <CandidateProfilePreview jdID={jdID} />,
    },
  ];
  return (
    <div className="candidate-profile-container">
      <Tabs
        type="card"
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
      />
    </div>
  );
}

export default CandidateProfile;
